import { SVGProps } from "react";

const GoogleSheetsLogoSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <path
      fill="#0F9D58"
      d="M29 4H10a3 3 0 0 0-3 3v34a3 3 0 0 0 3 3h28a3 3 0 0 0 3-3V16L29 4z"
    />
    <path fill="#87CEAC" d="M29 4l12 12H29z" />
    <path fill="#F1F1F1" d="M14 21h20v18H14z" />
    <path
      fill="#0F9D58"
      d="M14 21h20v2H14zM14 26h20v2H14zM14 31h20v2H14zM14 36h20v2H14zM19 21h2v18h-2zM27 21h2v18h-2z"
    />
  </svg>
);

export default GoogleSheetsLogoSvg;
